var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHandWrench = function SvgHandWrench(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11156_2487)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.9099 24.9014L37.948 23.8654L40.6647 21.1549C42.0666 19.7561 42.0666 17.4651 40.6647 16.0663C39.2628 14.6674 36.9668 14.6674 35.5648 16.0663L31.8101 19.8128",
    stroke: "#757575",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3769 32.2853C53.1494 31.0603 51.1374 31.0603 49.9098 32.2853L45.1394 37.0487C43.9119 38.2737 43.9119 40.2774 45.1394 41.5022C46.367 42.7271 48.3753 42.7271 49.603 41.5022L54.3769 36.7387C55.6047 35.514 55.6047 33.5102 54.3769 32.2853Z",
    stroke: "#757575",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2876 26.72C44.8102 27.1964 45.7915 26.2172 45.8066 26.2022C47.1668 24.7995 47.1518 22.5425 45.7649 21.155C44.3631 19.7562 42.0669 19.7562 40.6649 21.155L38.7856 23.0302",
    stroke: "#757575",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7303 56.5259C44.6584 54.8132 44.9842 53.0818 45.7156 51.4978L29.2335 35.0486M48.1897 42.3149L51.5542 45.6719C55.5782 43.827 60.5227 44.5529 63.8267 47.8495C66.4639 50.4808 67.4604 54.1554 66.8125 57.5731C66.1341 61.1607 64.2398 58.4463 63.8532 58.0608L59.2268 53.4447C57.609 51.8304 55.006 51.7624 53.3049 53.2443C51.8195 54.9418 51.8877 57.5391 53.5055 59.1534L58.1319 63.7694C58.5184 64.155 61.2389 66.0453 57.6432 66.722C54.2179 67.3685 50.535 66.3742 47.8981 63.7429C47.0757 62.9188 46.4127 61.9963 45.9088 61.0135M26.4146 20.5918L22.2845 16.4672C24.1335 12.4523 23.406 7.51871 20.102 4.22217C17.465 1.59089 13.7822 0.59652 10.3569 1.24305C6.76111 1.91973 9.48165 3.81005 9.86813 4.19561L14.4945 8.81164C16.1123 10.426 16.1806 13.0233 14.6953 14.7206C12.994 16.2027 10.391 16.1345 8.77323 14.5203L4.14683 9.90429C3.76035 9.5186 1.86591 6.80418 1.18751 10.392C0.539782 13.8096 1.53614 17.4843 4.1734 20.1156C7.47737 23.4121 12.4218 24.1381 16.4458 22.2932L20.8183 26.6558",
    stroke: "#757575",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1549 52.3147L24.8686 58.0157C25.7515 58.8966 25.7515 60.337 24.8686 61.2179L19.7877 66.2876C18.9048 67.1684 17.4612 67.1684 16.5784 66.2876L2.54785 52.2883C1.66504 51.4073 1.66504 49.967 2.54785 49.086L7.62885 44.0164C8.51166 43.1355 9.9552 43.1355 10.8381 44.0164L15.8623 49.0294",
    stroke: "#757575",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8687 58.0156L31.6357 51.2636C34.1706 48.7344 34.663 49.2788 37.6564 49.7061C38.9976 49.8988 40.9111 49.1843 42.4494 48.2392",
    stroke: "#757575",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9096 27.1964C48.5077 25.7977 46.2116 25.7977 44.8098 27.1964L41.0699 30.9278C39.6642 32.3304 39.6642 34.6176 41.0699 36.0164C42.4719 37.419 44.7679 37.419 46.1699 36.0164L49.9096 32.285C51.3153 30.8862 51.3153 28.5952 49.9096 27.1964Z",
    stroke: "#757575",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5327 30.4709C41.6351 29.4767 39.9906 27.9758 38.3007 26.2896L30.8706 18.876C30.1204 18.1275 28.8851 18.1275 28.1312 18.8798L21.9968 25.0005C20.6025 26.3917 19.9772 28.437 20.0872 30.2744C20.2577 33.0871 18.9466 35.93 15.0592 39.8051L10.8384 44.0166M29.2148 27.4011C29.2791 27.4691 31.7913 29.9719 31.8557 30.0362C33.8448 31.9567 37.8574 33.6125 40.4452 31.7677",
    stroke: "#757575",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2145 27.4005C31.4309 29.6121 30.8172 33.8086 27.8467 36.7725",
    stroke: "#757575",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11156_2487"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 68,
    fill: "currentColor"
  })))));
};
export default SvgHandWrench;